export default {
  // mock: http://localhost:3000/assignments?parent=true&tokenKey=123
  assignments: '/assignments',
  // mock: http://localhost:3000/assignmentsStatus?isbn=123&parent=true&tokenKey=123
  assignmentsStatus: '/assignmentsStatus',
  // mock http://localhost:3000/deliveryEvents?isbn=123&parent=true&tokenKey=123
  deliveryEvents: '/deliveryEvents',
};
